import { getAnalytics, logEvent } from 'firebase/analytics'
import * as React from 'react'

import { useFirebaseApp } from './firebase/FirebaseProvider'

export function Analytics() {
  const app = useFirebaseApp()

  React.useEffect(() => {
    const analytics = getAnalytics(app)
    logEvent(analytics, 'page_view', { page_location: location.href })
  }, [app])

  return null
}
